declare namespace $ {

	type $mol_view__sub_shm_ba_dashboard_1 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type __shm_ba_dashboard_2 = $mol_type_enforce<
		Parameters< $shm_ba_dashboard['summary_indicators'] >[0]
		,
		Parameters< ReturnType< $shm_ba_dashboard['Indicators_menu'] >['selected'] >[0]
	>
	type $shm_ba_dashboard_indicators__dashboard_id_shm_ba_dashboard_3 = $mol_type_enforce<
		ReturnType< $shm_ba_dashboard['app_id'] >
		,
		ReturnType< $shm_ba_dashboard_indicators['dashboard_id'] >
	>
	type $mol_link__arg_shm_ba_dashboard_4 = $mol_type_enforce<
		ReturnType< $shm_ba_dashboard['report_arg'] >
		,
		ReturnType< $mol_link['arg'] >
	>
	type $mol_link__current_shm_ba_dashboard_5 = $mol_type_enforce<
		ReturnType< $shm_ba_dashboard['report_current'] >
		,
		ReturnType< $mol_link['current'] >
	>
	type $mol_link__title_shm_ba_dashboard_6 = $mol_type_enforce<
		ReturnType< $shm_ba_dashboard['report_title'] >
		,
		ReturnType< $mol_link['title'] >
	>
	type $mol_string__value_shm_ba_dashboard_7 = $mol_type_enforce<
		ReturnType< $shm_ba_dashboard['report_title_draft'] >
		,
		ReturnType< $mol_string['value'] >
	>
	type $mol_string__submit_shm_ba_dashboard_8 = $mol_type_enforce<
		ReturnType< $shm_ba_dashboard['report_title_commit'] >
		,
		ReturnType< $mol_string['submit'] >
	>
	type $mol_string__event_shm_ba_dashboard_9 = $mol_type_enforce<
		({ 
			blur( next?: ReturnType< $shm_ba_dashboard['report_title_commit'] > ): ReturnType< $shm_ba_dashboard['report_title_commit'] >,
			keydown( next?: ReturnType< $shm_ba_dashboard['report_title_keydown'] > ): ReturnType< $shm_ba_dashboard['report_title_keydown'] >,
		})  & ReturnType< $mol_string['event'] >
		,
		ReturnType< $mol_string['event'] >
	>
	type $mol_button_minor__click_shm_ba_dashboard_10 = $mol_type_enforce<
		ReturnType< $shm_ba_dashboard['report_delete_ask'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_button_minor__sub_shm_ba_dashboard_11 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_button_minor['sub'] >
	>
	type $mol_text__text_shm_ba_dashboard_12 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_text['text'] >
	>
	type $mol_button_minor__title_shm_ba_dashboard_13 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_minor['title'] >
	>
	type $mol_button_minor__click_shm_ba_dashboard_14 = $mol_type_enforce<
		ReturnType< $shm_ba_dashboard['report_delete_confirm'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_button_minor__title_shm_ba_dashboard_15 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_minor['title'] >
	>
	type $mol_button_minor__click_shm_ba_dashboard_16 = $mol_type_enforce<
		ReturnType< $shm_ba_dashboard['report_delete_cancel'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_view__sub_shm_ba_dashboard_17 = $mol_type_enforce<
		ReturnType< $shm_ba_dashboard['report_settings_content'] >
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_pick__align_shm_ba_dashboard_18 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_pick['align'] >
	>
	type $mol_pick__showed_shm_ba_dashboard_19 = $mol_type_enforce<
		ReturnType< $shm_ba_dashboard['report_settings_showed'] >
		,
		ReturnType< $mol_pick['showed'] >
	>
	type $mol_pick__auto_shm_ba_dashboard_20 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_pick['auto'] >
	>
	type $mol_pick__hint_shm_ba_dashboard_21 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_pick['hint'] >
	>
	type $mol_pick__trigger_content_shm_ba_dashboard_22 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_pick['trigger_content'] >
	>
	type $mol_pick__bubble_content_shm_ba_dashboard_23 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_pick['bubble_content'] >
	>
	type $mol_view__attr_shm_ba_dashboard_24 = $mol_type_enforce<
		({ 
			'settings_opened': ReturnType< $shm_ba_dashboard['report_settings_showed'] >,
		})  & ReturnType< $mol_view['attr'] >
		,
		ReturnType< $mol_view['attr'] >
	>
	type $mol_view__sub_shm_ba_dashboard_25 = $mol_type_enforce<
		ReturnType< $shm_ba_dashboard['report_actions'] >
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_shm_ba_dashboard_26 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_shm_ba_dashboard_27 = $mol_type_enforce<
		ReturnType< $shm_ba_dashboard['report_tab_rows'] >
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_button_download__title_shm_ba_dashboard_28 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_download['title'] >
	>
	type $mol_button_download__enabled_shm_ba_dashboard_29 = $mol_type_enforce<
		ReturnType< $shm_ba_dashboard['has_source'] >
		,
		ReturnType< $mol_button_download['enabled'] >
	>
	type $mol_button_download__click_shm_ba_dashboard_30 = $mol_type_enforce<
		ReturnType< $shm_ba_dashboard['csv_download'] >
		,
		ReturnType< $mol_button_download['click'] >
	>
	type $mol_view__sub_shm_ba_dashboard_31 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $shm_ba_file_picker__app_id_shm_ba_dashboard_32 = $mol_type_enforce<
		ReturnType< $shm_ba_dashboard['app_id'] >
		,
		ReturnType< $shm_ba_file_picker['app_id'] >
	>
	type $shm_ba_file_picker__file_uri_shm_ba_dashboard_33 = $mol_type_enforce<
		ReturnType< $shm_ba_dashboard['file_uri'] >
		,
		ReturnType< $shm_ba_file_picker['file_uri'] >
	>
	type $shm_ba_file_picker__local_file_key_shm_ba_dashboard_34 = $mol_type_enforce<
		ReturnType< $shm_ba_dashboard['local_file_key'] >
		,
		ReturnType< $shm_ba_file_picker['local_file_key'] >
	>
	type $shm_ba_file_picker__pb_files_collection_shm_ba_dashboard_35 = $mol_type_enforce<
		ReturnType< $shm_ba_dashboard['pb_files_collection'] >
		,
		ReturnType< $shm_ba_file_picker['pb_files_collection'] >
	>
	type $shm_ba_file_picker__pb_files_field_shm_ba_dashboard_36 = $mol_type_enforce<
		ReturnType< $shm_ba_dashboard['pb_files_field'] >
		,
		ReturnType< $shm_ba_file_picker['pb_files_field'] >
	>
	type $shm_ba_file_picker__remote_files_shm_ba_dashboard_37 = $mol_type_enforce<
		ReturnType< $shm_ba_dashboard['dashboard_model_files'] >
		,
		ReturnType< $shm_ba_file_picker['remote_files'] >
	>
	type $shm_ba_file_picker__remote_files_forced_shm_ba_dashboard_38 = $mol_type_enforce<
		boolean
		,
		ReturnType< $shm_ba_file_picker['remote_files_forced'] >
	>
	type $mol_page__title_content_shm_ba_dashboard_39 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_page['title_content'] >
	>
	type $mol_page__tools_shm_ba_dashboard_40 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_page['tools'] >
	>
	type $mol_page__body_shm_ba_dashboard_41 = $mol_type_enforce<
		ReturnType< $shm_ba_dashboard['report_rows'] >
		,
		ReturnType< $mol_page['body'] >
	>
	type $shm_ba_filter_panel__has_source_shm_ba_dashboard_42 = $mol_type_enforce<
		ReturnType< $shm_ba_dashboard['has_source'] >
		,
		ReturnType< $shm_ba_filter_panel['has_source'] >
	>
	type $shm_ba_filter_panel__state_shm_ba_dashboard_43 = $mol_type_enforce<
		ReturnType< $shm_ba_dashboard['filter_state_store'] >
		,
		ReturnType< $shm_ba_filter_panel['state'] >
	>
	type $shm_ba_filter_panel__data_shm_ba_dashboard_44 = $mol_type_enforce<
		ReturnType< $shm_ba_dashboard['data'] >
		,
		ReturnType< $shm_ba_filter_panel['data'] >
	>
	type $shm_ba_filter_panel__process_monitor_opened_shm_ba_dashboard_45 = $mol_type_enforce<
		ReturnType< $shm_ba_dashboard['process_monitor_opened'] >
		,
		ReturnType< $shm_ba_filter_panel['process_monitor_opened'] >
	>
	type $mol_view__sub_shm_ba_dashboard_46 = $mol_type_enforce<
		ReturnType< $shm_ba_dashboard['summary_data_rows'] >
		,
		ReturnType< $mol_view['sub'] >
	>
	type $shm_ba_posts__table_shm_ba_dashboard_47 = $mol_type_enforce<
		ReturnType< $shm_ba_dashboard['query_posts_page'] >
		,
		ReturnType< $shm_ba_posts['table'] >
	>
	type $shm_ba_posts__table_count_shm_ba_dashboard_48 = $mol_type_enforce<
		ReturnType< $shm_ba_dashboard['query_posts_count'] >
		,
		ReturnType< $shm_ba_posts['table_count'] >
	>
	type $shm_ba_posts__highlight_shm_ba_dashboard_49 = $mol_type_enforce<
		ReturnType< $shm_ba_dashboard['search_query'] >
		,
		ReturnType< $shm_ba_posts['highlight'] >
	>
	type $shm_ba_posts__sort_shm_ba_dashboard_50 = $mol_type_enforce<
		ReturnType< $shm_ba_dashboard['posts_sort'] >
		,
		ReturnType< $shm_ba_posts['sort'] >
	>
	type $shm_ba_posts__sort_order_shm_ba_dashboard_51 = $mol_type_enforce<
		ReturnType< $shm_ba_dashboard['posts_sort_order'] >
		,
		ReturnType< $shm_ba_posts['sort_order'] >
	>
	type $shm_ba_posts__page_shm_ba_dashboard_52 = $mol_type_enforce<
		ReturnType< $shm_ba_dashboard['posts_page'] >
		,
		ReturnType< $shm_ba_posts['page'] >
	>
	type $mol_view__sub_shm_ba_dashboard_53 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_shm_ba_dashboard_54 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $shm_ba_chart_tags__rows_shm_ba_dashboard_55 = $mol_type_enforce<
		ReturnType< $shm_ba_dashboard['tag_messages_pie'] >
		,
		ReturnType< $shm_ba_chart_tags['rows'] >
	>
	type $shm_ba_converter__data_shm_ba_dashboard_56 = $mol_type_enforce<
		ReturnType< $shm_ba_dashboard['data'] >
		,
		ReturnType< $shm_ba_converter['data'] >
	>
	type $shm_ba_report_renderer__report_shm_ba_dashboard_57 = $mol_type_enforce<
		ReturnType< $shm_ba_dashboard['report_current_model'] >
		,
		ReturnType< $shm_ba_report_renderer['report'] >
	>
	type $shm_ba_report_renderer__dashboard_shm_ba_dashboard_58 = $mol_type_enforce<
		ReturnType< $shm_ba_dashboard['dashboard_self'] >
		,
		ReturnType< $shm_ba_report_renderer['dashboard'] >
	>
	type $mol_view__sub_shm_ba_dashboard_59 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_list__rows_shm_ba_dashboard_60 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_list['rows'] >
	>
	type $mol_view__sub_shm_ba_dashboard_61 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $shm_ba_summary__table_shm_ba_dashboard_62 = $mol_type_enforce<
		ReturnType< $shm_ba_dashboard['query_summary'] >
		,
		ReturnType< $shm_ba_summary['table'] >
	>
	type $shm_ba_summary__selected_shm_ba_dashboard_63 = $mol_type_enforce<
		ReturnType< $shm_ba_dashboard['chart_metric'] >
		,
		ReturnType< $shm_ba_summary['selected'] >
	>
	type $shm_ba_summary__sort_shm_ba_dashboard_64 = $mol_type_enforce<
		ReturnType< $shm_ba_dashboard['posts_sort'] >
		,
		ReturnType< $shm_ba_summary['sort'] >
	>
	type $shm_ba_summary__sort_order_shm_ba_dashboard_65 = $mol_type_enforce<
		ReturnType< $shm_ba_dashboard['posts_sort_order'] >
		,
		ReturnType< $shm_ba_summary['sort_order'] >
	>
	type $shm_ba_summary__page_shm_ba_dashboard_66 = $mol_type_enforce<
		ReturnType< $shm_ba_dashboard['posts_page'] >
		,
		ReturnType< $shm_ba_summary['page'] >
	>
	type $shm_ba_chart_timeseries__rows_shm_ba_dashboard_67 = $mol_type_enforce<
		ReturnType< $shm_ba_dashboard['chart_timeseries'] >
		,
		ReturnType< $shm_ba_chart_timeseries['rows'] >
	>
	type $shm_ba_chart_timeseries__title_shm_ba_dashboard_68 = $mol_type_enforce<
		ReturnType< $shm_ba_dashboard['chart_metric'] >
		,
		ReturnType< $shm_ba_chart_timeseries['title'] >
	>
	type $shm_ba_chart_timeseries__group_shm_ba_dashboard_69 = $mol_type_enforce<
		ReturnType< $shm_ba_dashboard['chart_group'] >
		,
		ReturnType< $shm_ba_chart_timeseries['group'] >
	>
	type $shm_ba_chart_timeseries__group_options_shm_ba_dashboard_70 = $mol_type_enforce<
		ReturnType< $shm_ba_dashboard['chart_group_options'] >
		,
		ReturnType< $shm_ba_chart_timeseries['group_options'] >
	>
	type $shm_ba_chart_timeseries__period_pick_shm_ba_dashboard_71 = $mol_type_enforce<
		ReturnType< $shm_ba_dashboard['chart_period_pick'] >
		,
		ReturnType< $shm_ba_chart_timeseries['period_pick'] >
	>
	type $shm_ba_chart_timeseries__period_range_pick_shm_ba_dashboard_72 = $mol_type_enforce<
		ReturnType< $shm_ba_dashboard['chart_period_range_pick'] >
		,
		ReturnType< $shm_ba_chart_timeseries['period_range_pick'] >
	>
	type $shm_ba_chart_timeseries__overlay_series_shm_ba_dashboard_73 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $shm_ba_chart_timeseries['overlay_series'] >
	>
	type $shm_ba_chart_timeseries__tools_left_shm_ba_dashboard_74 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $shm_ba_chart_timeseries['tools_left'] >
	>
	type $mol_list__rows_shm_ba_dashboard_75 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_list['rows'] >
	>
	type $mol_list__rows_shm_ba_dashboard_76 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_list['rows'] >
	>
	type $mol_list__rows_shm_ba_dashboard_77 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_list['rows'] >
	>
	export class $shm_ba_dashboard extends $mol_book2 {
		Theme( ): $mol_theme_auto
		ba_mcp_client_auto( ): any
		dashboard_title( ): string
		Logo( ): $mol_view
		summary_indicators( next?: ReturnType< ReturnType< $shm_ba_dashboard['Indicators_menu'] >['selected'] > ): ReturnType< ReturnType< $shm_ba_dashboard['Indicators_menu'] >['selected'] >
		Indicators_menu( ): $shm_ba_dashboard_indicators
		report_arg( id: any): Record<string, any>
		report_current( id: any): boolean
		report_title( id: any): string
		Report_link( id: any): $mol_link
		report_settings_showed( id: any, next?: boolean ): boolean
		report_settings_outside_listener( id: any): any
		Report_settings_icon( id: any): $mol_icon_dots_vertical
		report_title_draft( id: any, next?: string ): string
		report_title_commit( id: any, next?: any ): any
		report_title_keydown( id: any, next?: any ): any
		Report_title_input( id: any): $mol_string
		report_delete_ask( id: any, next?: any ): any
		Report_delete_icon( id: any): $mol_icon_trash_can
		Report_delete( id: any): $mol_button_minor
		Report_delete_text( id: any): $mol_text
		report_delete_confirm( id: any, next?: any ): any
		Report_delete_yes( id: any): $mol_button_minor
		report_delete_cancel( id: any, next?: any ): any
		Report_delete_no( id: any): $mol_button_minor
		report_settings_content( id: any): readonly($mol_view)[]
		Report_settings_content( id: any): $mol_view
		Report_settings( id: any): $mol_pick
		report_actions( id: any): readonly($mol_view)[]
		Report_actions( id: any): $mol_view
		Report_tab( id: any): $mol_view
		report_tab_rows( ): readonly($mol_view)[]
		Report_tabs( ): $mol_view
		csv_download( next?: any ): any
		Csv_download( ): $mol_button_download
		File_label( ): $mol_view
		file_uri( next?: string ): string
		local_file_key( next?: string ): string
		dashboard_model_files( ): readonly(any)[]
		File_picker( ): $shm_ba_file_picker
		report_rows( ): readonly(any)[]
		Report_page( ): $mol_page
		process_monitor_opened( next?: boolean ): boolean
		Filters_page( ): $shm_ba_filter_panel
		dashboard_pages( ): readonly(any)[]
		summary_data_rows( ): readonly(any)[]
		Summary_data( ): $mol_view
		query_posts_page( ): any
		query_posts_count( ): number
		search_query( next?: string ): string
		posts_sort( next?: string ): string
		posts_sort_order( next?: string ): string
		posts_page( next?: number ): number
		Posts( ): $shm_ba_posts
		summary_loading_title( ): string
		Summary_loading_title( ): $mol_view
		Summary_loading_dots( ): $shm_dotsloader
		Summary_loading_content( ): $mol_view
		query_summary( ): any
		chart_metric( next?: string ): string
		chart_timeseries( ): readonly(any)[]
		chart_group( next?: string ): string
		chart_group_options( ): Record<string, any>
		chart_period_pick( next?: any ): any
		chart_period_range_pick( next?: any ): any
		tag_messages_pie( ): readonly(any)[]
		Tag_messages_pie_chart( ): $shm_ba_chart_tags
		Converter( ): $shm_ba_converter
		report_current_model( ): any
		Custom_report_renderer( ): $shm_ba_report_renderer
		file( next?: any ): any
		files( next?: readonly(File)[] ): readonly(File)[]
		dashboard_model( ): $shm_ba_dashboard_model | null
		agent_enabled( ): boolean
		pb_files_collection( ): string
		pb_files_field( ): string
		has_source( ): boolean
		period( next?: ({ 
			'from': string,
			'to': string,
		})  ): ({ 
			'from': string,
			'to': string,
		}) 
		period_all( ): ({ 
			'from': string,
			'to': string,
		}) 
		data( ): $shm_ba_data | null
		query_posts( ): any
		tags_filter( next?: Record<string, any> ): Record<string, any>
		message_types_filter( next?: Record<string, any> ): Record<string, any>
		source_types_filter( next?: Record<string, any> ): Record<string, any>
		authors_filter( next?: Record<string, any> ): Record<string, any>
		sources_filter( next?: Record<string, any> ): Record<string, any>
		search_query_draft( next?: string ): string
		search_mode( next?: string ): string
		search_case_sensitive( next?: boolean ): boolean
		screen( next?: string ): string
		report_id( next?: string ): string
		report_current_title( ): string
		dashboard_self( ): $shm_ba_dashboard | null
		app_id( ): string
		filter_state_store( ): $shm_ba_filter_state_store | null
		placeholders( ): readonly(any)[]
		plugins( ): readonly(any)[]
		auto( ): readonly(any)[]
		pages( ): ReturnType< $shm_ba_dashboard['dashboard_pages'] >
		Process_monitor( ): $shm_hitalama_process_monitor
		Ba_mcp_client( ): $shm_ba_mcp_client
		Empty( ): $mol_view
		Summary_screen( ): $mol_list
		Summary_loading( ): $mol_view
		Summary( ): $shm_ba_summary
		Timeseries_chart( ): $shm_ba_chart_timeseries
		Charts_screen( ): $mol_list
		Converter_screen( ): $mol_list
		Custom_report_screen( ): $mol_list
	}
	
}

//# sourceMappingURL=dashboard.web.view.tree.d.ts.map